import {
  StyledBody,
  StyledContainer,
  StyledHalfImage,
  StyledWrapper,
} from "components/general/stylingHero";
import { useTheme } from "components/services/themeContext";
import { businessData } from "data/businessData";

const Hero = () => {
  const { theme } = useTheme();
  const imageSrc =
    theme === "light" ? "/images/business/redact-pro-dark.svg" : "/images/business/redact-pro.svg";

  return (
    <StyledWrapper>
      <StyledContainer style={{ flexDirection: "column" }}>
        <div style={{ padding: "4rem 0", textAlign: "center" }} className="hero__half">
          <h1 className="hero__title">{businessData.title}</h1>
        </div>
        <StyledHalfImage>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {/* eslint-disable-next-line @next/next/no-img-element*/}
            <img
              style={{ maxWidth: "100%", height: "auto" }}
              src={imageSrc}
              alt="Redact pro"
              width={442}
              height={108}
            />
          </div>
        </StyledHalfImage>
        <div className="hero__half" style={{ padding: "4rem 0", textAlign: "center" }}>
          <StyledBody>{businessData.subtitle}</StyledBody>
        </div>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
